import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { OrganizerSharedActivityService } from '~/organizer/shared/services/activity/activity.service';
import { BookingItemsGroupByUserIdInterface } from '~/organizer/shared/services/activity/interfaces/booking-items-group-by-user-id.interface';

export const OrganizerSharedTimeslotParticipantSingleResolver: ResolveFn<
  BookingItemsGroupByUserIdInterface
> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  activityService: OrganizerSharedActivityService = inject(
    OrganizerSharedActivityService
  )
): Observable<BookingItemsGroupByUserIdInterface> => {
  const timeslotId = route.paramMap.get('id');
  const userId = route.queryParams.userId;

  return activityService
    .getTimeslotBookingItemsByUserId(timeslotId, userId)
    .pipe(
      tap((bookingItemGroupByUserId) => {
        if (!bookingItemGroupByUserId) {
          throw new Error('Not found');
        }
      }),
      catchError((error) => {
        console.error('TimeslotParticipantSingleResolver', error);
        router.navigateByUrl('/404');

        return throwError(() => error);
      })
    );
};
